// extracted by mini-css-extract-plugin
export default {"container":"InsightsEditButtons_container__HLvWx"};